declare global {
  interface String {
    toDateFormat(): Date;
    toPersianWords(): string;
    toPersianDigit(): string;
    toActualNumber(): string;
    toCurrency(minimumFractionDigits?: number,
      maximumFractionDigits?: number, append?: string,): string;
    fromNumberToPersianLetter(): string;
  }

}

// Function to convert numbers to Persian numerals
const persianNumbers: { [key: string]: string } = {
  ',': ',',
  '.': '.',
  '0': '۰',
  '1': '۱',
  '2': '۲',
  '3': '۳',
  '4': '۴',
  '5': '۵',
  '6': '۶',
  '7': '۷',
  '8': '۸',
  '9': '۹',
};

const persianNumbersRev: { [key: string]: string } = {
  ',': ',',
  '.': '.',
  '۰': '0',
  '۱': '1',
  '۲': '2',
  '۳': '3',
  '۴': '4',
  '۵': '5',
  '۶': '6',
  '۷': '7',
  '۸': '8',
  '۹': '9',
};
String.prototype.toPersianWords = function (): string {
  const num = parseInt(this.replace(/,/g, "").trim());
  if (isNaN(num)) return this.toString();
  if (num === 0) return "صفر";

  const ones = ["","یک","دو","سه","چهار","پنج","شش","هفت","هشت","نه"];
  const teens = ["ده","یازده","دوازده","سیزده","چهارده","پانزده","شانزده","هفده","هجده","نوزده"];
  const tens = ["","ده","بیست","سی","چهل","پنجاه","شصت","هفتاد","هشتاد","نود"];
  const hundreds = ["","یکصد","دویست","سیصد","چهارصد","پانصد","ششصد","هفتصد","هشتصد","نهصد"];
  const thousands = ["","هزار","میلیون","میلیارد","تریلیون"];

  const splitNumber = (n: number) => {
    const parts: number[] = [];
    while (n > 0) {
      parts.push(n % 1000);
      n = Math.floor(n / 1000);
    }
    return parts;
  };

  const numberToWords = (n: number) => {
    let w: string[] = [];
    if (n >= 100) {
      w.push(hundreds[Math.floor(n / 100)]);
      n %= 100;
    }
    if (n >= 10 && n < 20) {
      w.push(teens[n - 10]);
      n = 0;
    } else if (n >= 20) {
      w.push(tens[Math.floor(n / 10)]);
      n %= 10;
    }
    if (n > 0) {
      w.push(ones[n]);
    }
    return w.filter(Boolean).join(" و ");
  };

  const parts = splitNumber(num);
  let words: string[] = [];
  for (let i = parts.length - 1; i >= 0; i--) {
    if (parts[i] !== 0) {
      let partWord = numberToWords(parts[i]);
      if (thousands[i]) partWord += " " + thousands[i];
      words.push(partWord);
    }
  }

  return words.join(" و ");
};
// Function to convert a Persian string of numbers to actual numerals
// Function to convert a Persian string of numbers to actual numerals
String.prototype.toActualNumber = function (): string {
  return this.replace(/[۰-۹,.]/g, (digit) => persianNumbersRev[digit]);
};


String.prototype.toPersianDigit = function (): string {
  return this.replace(/[0-9,.]/g, (digit) => persianNumbers[digit]);
};

String.prototype.toDateFormat = function (): Date {
  return new Date(this.toString());
};

String.prototype.toCurrency = function (minimumFractionDigits?: number,
  maximumFractionDigits?: number, append?: string): string {
  const number = parseFloat(this.replace(/,/g, '')); // Remove existing commas and parse the string to a number
  if (isNaN(number)) return this.toString(); // If the number is invalid, return the original string
  return number.toLocaleString('en-US') + (append ? " " + append : "");
};


const persianLetters: { [key: string]: string } = {
  "0-0": "",
  "0-1": "یک",
  "0-2": "دو",
  "0-3": "سه",
  "0-4": "چهار",
  "0-5": "پنج",
  "0-6": "شش",
  "0-7": "هفت",
  "0-8": "هشت",
  "0-9": "نه",
  "10": "ده",
  "11": "یازده",
  "12": "دوازده",
  "13": "سیزده",
  "14": "چهارده",
  "15": "پانزده",
  "16": "شانزده",
  "17": "هفده",
  "18": "هجده",
  "19": "نوزده",
  "1-0": "",
  "1-2": "بیست",
  "1-3": "سی",
  "1-4": "چهل",
  "1-5": "پنجاه",
  "1-6": "شصت",
  "1-7": "هفتاد",
  "1-8": "هشتاد",
  "1-9": "نود",
  "2-0": "",
  "2-1": "صد",
  "2-2": "دویست",
  "2-3": "سیصد",
  "2-4": "چهارصد",
  "2-5": "پانصد",
  "2-6": "ششصد",
  "2-7": "هفتصد",
  "2-8": "هشتصد",
  "2-9": "نهصد",
  "0": "",
  "1": "هزار",
  "2": "میلیون",
  "3": "میلیارد",
  "4": "بیلیون",
};

String.prototype.fromNumberToPersianLetter = function () {
  if (this === "0") return "صفر";
  let inp = this;
  let temp: string = "";
  let output: string = "";
  let index = inp.length % 3;
  let value: number = 0;
  let camma: string = "";

  if (index > 0) {
    temp = inp.substring(0, index);
    value = parseInt(temp);

    if (value >= 10 && value < 20) output += " " + persianLetters[value.toString()];
    else {
      output += " " + persianLetters["1-" + Math.floor((value % 100) / 10)];
      if (persianLetters["1-" + Math.floor((value % 100) / 10)] !== "") camma = " و";
      output += " " + persianLetters["0-" + (value % 10)];
      camma = "";
    }

    output += " " + persianLetters[((inp.length - index) / 3).toString()];
  }

  while (index + 3 <= inp.length) {
    temp = inp.substring(index, index + 3);
    value = parseInt(temp);
    camma = "";

    if (persianLetters["2-" + Math.floor(value / 100)] !== "" && output.length > 0)
      camma = " و";

    output += camma + " " + persianLetters["2-" + Math.floor(value / 100)];

    if (value % 100 >= 10 && value % 100 < 20) {
      if (persianLetters[(value % 100) + ""] !== "" && output.length > 0) camma = " و";
      output += camma + " " + persianLetters[value % 100];
    } else {
      camma = "";
      if (
        persianLetters["1-" + Math.floor((value % 100) / 10)] !== "" &&
        output.length > 0
      )
        camma = " و";
      output += camma + " " + persianLetters["1-" + Math.floor((value % 100) / 10)];
      camma = "";
      if (persianLetters["0-" + (value % 10)] !== "" && output.length > 0)
        camma = " و";
      output += camma + " " + persianLetters["0-" + (value % 10)];
    }

    index += 3;
    if (value !== 0)
      output += " " + persianLetters[((inp.length - index) / 3).toString()];
  }

  return (parseInt(this.toString()) < 0 ? "منفی " : "") + output;
};


export default {};
